import { useState } from "react";
import "../styles/ConfirmationModal.scss";

interface ConfirmationModalProps {
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
    requireDoubleConfirm?: boolean;
    loading?: boolean;
}

export default function ConfirmationModal({
    title,
    message,
    confirmText = "Подтвердить",
    cancelText = "Отмена",
    onConfirm,
    onCancel,
    requireDoubleConfirm = false,
    loading = false,
}: ConfirmationModalProps) {
    const [step, setStep] = useState(1);

    const handleConfirm = () => {
        if (requireDoubleConfirm && step === 1) {
            setStep(2);
        } else {
            onConfirm();
        }
    };

    return (
        <div className="modal-overlay" onClick={onCancel}>
            <div className="modal-content confirmation-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{title}</h2>
                </div>

                <div className="modal-body">
                    {step === 1 ? (
                        <p>{message}</p>
                    ) : (
                        <div className="double-confirm">
                            <p className="warning">⚠️ Вы уверены?</p>
                            <p>Это действие нельзя будет отменить</p>
                        </div>
                    )}
                </div>

                <div className="modal-actions">
                    <button 
                        type="button" 
                        onClick={onCancel} 
                        className="btn-secondary"
                        disabled={loading}
                    >
                        {cancelText}
                    </button>
                    <button 
                        type="button" 
                        onClick={handleConfirm} 
                        className="btn-primary"
                        disabled={loading}
                        style={{ minHeight: '40px' }}
                    >
                        {loading ? (
                            <>
                                <span className="spinner" style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                Обработка...
                            </>
                        ) : (
                            step === 1 ? confirmText : "Да, подтверждаю"
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}
